//import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
//import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./pages/AuthContext";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import GenerateToken from "./pages/GenerateToken";
import AddCounters from "./pages/AddCounters";
import CounterList from "./pages/CounterList";
import AddUser from "./pages/AddUser";
import UserList from "./pages/UserList";
import AddServices from "./pages/AddServices";
import ServiceList from "./pages/ServiceList";
import CounterPanel from "./pages/CounterPanel";
import DisplayBoard from "./pages/DisplayBoard";
import DisplayBoardCounterWise from "./pages/DisplayBoardCounterWise";
import ProtectedRoute from "./pages/ProtectedRoute";
// import Navbar from "./pages/Navbar";
import Unauthorized from "./pages/Unauthorized";
import AddGrievance from "./pages/AddGrievance";
import GrievanceList from "./pages/GrievanceList";
import Layout from "./pages/Layout";
import BarcodeScanner from "./pages/BarcodeScanner";
import MenuMaster from "./pages/MenuMaster";
import AddMenu from "./pages/AddMenu";
import TMReport from "./pages/TMReport";
import ThemeDemo from "./pages/ThemeDemo.jsx";

import AssignMenu from "./pages/AssignMenu";
import ViewAssignMenu from "./pages/ViewAssignMenu";

import DashboardCharts from "./pages/DashboardCharts";

import ThemeProvider from "./theme/ThemeProvider.jsx";

import AddNews from "./pages/AddNews.jsx";
import NewsList from "./pages/NewsList.jsx";
import AddNotice from "./pages/AddNotice.jsx";
import NoticeList from "./pages/NoticeList.jsx";
import AddDownload from "./pages/AddDownload.jsx";
import DownloadList from "./pages/DownloadList.jsx";
import AddBuilding from "./pages/AddBuilding.jsx";
import BuildingVerification from "./pages/BuildingVerification.jsx";

import CarbonBar from "./pages/CarbonBar.jsx";

import AddCommunityCenter from "./pages/AddCommunityCenter.jsx"
import CommunityCenterList from "./pages/CommunityCenterList.jsx";
import EditCommunityCenter from "./pages/EditCommunityCenter.jsx";
import CommunityCenterBooking from "./pages/CommunityCenterBooking.jsx";
import CommunityCenterBookingDetails from "./pages/CommunityCenterBookingDetails.jsx";
import CommunityCenterBookingList from "./pages/CommunityCenterBookingList.jsx";
import DogRegistration from "./pages/DogRegistration";
import DogRegistrationList from "./pages/DogRegistrationList"

// import TMReport from "./pages/TMReport.jsx"

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            element={
              <ProtectedRoute>
                <ThemeProvider>
                  <Layout />
                </ThemeProvider>
              </ProtectedRoute>
            }
          >
            <Route path="/ThemeDemo" element={<ThemeDemo />} />
              <Route path="/CarbonBar" element={<CarbonBar />} />
              <Route path="/AddCommunityCenter" element={<AddCommunityCenter />} />
              <Route path="/CommunityCenterList" element={<CommunityCenterList />} />
             {/* <Route path="/EditCommunityCenter" element={<EditCommunityCenter />} />  */}
            <Route
    path="/EditCommunityCenter/:id"
    element={
        <ProtectedRoute>
            <EditCommunityCenter />
        </ProtectedRoute>
    }
/>

<Route
    path="/CommunityCenterBooking/:id"
    element={
        <ProtectedRoute>
            <CommunityCenterBooking />
        </ProtectedRoute>
    }
/>

<Route
    path="/CommunityCenterBookingDetails/:id"
    element={
        <ProtectedRoute>
            <CommunityCenterBookingDetails />
        </ProtectedRoute>
    }
/>

<Route
  path="/DogRegistration"
  element={
    <ProtectedRoute>
      <DogRegistration />
    </ProtectedRoute>
  }
/>

<Route path="/DogRegistrationList" element={<DogRegistrationList />} />
<Route path="/CommunityCenterBookingList" element={<CommunityCenterBookingList />} />
              <Route path="/AddBuilding" element={<AddBuilding />} />
            <Route path="/BuildingVerification" element={<BuildingVerification />} />
            <Route path="/AddNews" element={<AddNews />} />
            <Route path="/NewsList" element={<NewsList />} />
            <Route path="/AddNotice" element={<AddNotice />} />
            <Route path="/NoticeList" element={<NoticeList />} />
            <Route path="/AddDownload" element={<AddDownload />} />
            <Route path="/DownloadList" element={<DownloadList />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/MenuMaster" element={<MenuMaster />} />
            <Route path="/AddMenu" element={<AddMenu />} />
            <Route path="/AssignMenu" element={<AssignMenu />} />
            <Route path="/ViewAssignMenu" element={<ViewAssignMenu />} />
            <Route path="/TMReport" element={<TMReport />} />
            <Route path="/AddCounters" element={<AddCounters />} />
            <Route path="/CounterList" element={<CounterList />} />

            <Route path="/AddServices" element={<AddServices />} />
            <Route path="/ServiceList" element={<ServiceList />} />

            <Route path="/AddUser" element={<AddUser />} />
            <Route path="/UserList" element={<UserList />} />

            <Route path="/GenerateToken" element={<GenerateToken />} />

            <Route path="/CounterPanel" element={<CounterPanel />} />

            <Route path="/DisplayBoard" element={<DisplayBoard />} />

            <Route
              path="/DisplayBoardCounterWise"
              element={<DisplayBoardCounterWise />}
            />
            <Route path="/GrievanceList" element={<GrievanceList />} />

            <Route path="/AddGrievance" element={<AddGrievance />} />
            <Route path="/DashboardCharts" element={<DashboardCharts />} />
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/BarcodeScanner" element={<BarcodeScanner />} />
          <Route path="/Unauthorized" element={<Unauthorized />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
